export { default } from '@telexpress_auth/vue-marketing-pitch';
